// extracted by mini-css-extract-plugin
export default {"row":"Item_row__2Vo66","id":"Item_id__NcYw3","idContainer":"Item_idContainer__MdHtI","detailsContainer":"Item_detailsContainer__WKN18"};